import { render, staticRenderFns } from "./DashboardHomeView.vue?vue&type=template&id=315e2671&scoped=true&"
import script from "./DashboardHomeView.vue?vue&type=script&lang=js&"
export * from "./DashboardHomeView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHomeView.vue?vue&type=style&index=0&id=315e2671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e2671",
  null
  
)

/* custom blocks */
import block0 from "./DashboardHomeView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports